import { render, staticRenderFns } from "./RegisterBox.vue?vue&type=template&id=7c13878d"
import script from "./RegisterBox.vue?vue&type=script&lang=ts"
export * from "./RegisterBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports